import styled from "styled-components";
import {
  CardContent,
  Type,
  Button,
} from "discover.medical.react-component-library";

export const CardContentStyled = styled(CardContent)`
  padding-top: 0;
`;

export const UserInactivityText = styled(Type)`
  padding: 0 1rem 1rem;
`;

export const ResumeButtonStyled = styled(Button)`
  margin-left: 1rem;
`;
